<template>
  <div class="modal-dim on">
    <div class="modal-wrap">
      <div class="detail-view-modal">
        <div class="swiper mySwiper">
          <Swiper
            :initialSlide="idx"
            :zoom="true"
            :pagination="{ type: 'bullets', el: '.swiper-pagination' }"
            :modules="[Pagination, Navigation, Zoom]"
            :navigation="true"
          >
            <SwiperSlide v-for="(file, index) in contents" :key="index">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="slide">
                    <div class="swiper-zoom-container">
                      <img ref="imageLayout" :src="getImagePath(file.storedFileName)" alt="photo" />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <div class="swiper-button-close" @click.stop="$emit('close')"></div>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, onMounted, reactive, ref } from 'vue';
import { getImagePath } from '@/common/utils/Util';
import store from '@/store';
import { Navigation, Pagination, Zoom } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const emits = defineEmits(['close']);
const props = defineProps(['data']);
const { contents, idx } = props.data;
const detail = computed(() => store.getters['business/getDetail']);
const container = ref();

const imageLayout = ref();

const regData = reactive({
  businessNo: null,
  reason: ''
});
onMounted(() => {});

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped>
.modal-dim.on {
  background: rgba(0, 0, 0, 0.9) !important;
}
</style>
